import React, { ReactElement, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { routes } from 'static/routes';
import { Header, ProgressCircle } from '@ds/ui';
import { ContainerLayout } from 'layouts';
import Center = Header.Center;
import VerifyApplicationContext from 'contexts/VerifyApplicationContext';
import { useNavigateToErrorPage } from 'hooks';

const StartWorkflowPage = (): ReactElement => {
    const context = useContext(VerifyApplicationContext);
    const history = useHistory();
    const navigateToErrorPage = useNavigateToErrorPage();

    useEffect(() => {
        if (!context.configurationState) {
            return;
        }

        if (context.configurationState === 'Error') {
            navigateToErrorPage(context.exception?.message || 'Exception');
        } else if (context.isDocumentLocked) {
            history.push(routes.DocumentLocked);
        } else if (!!context.phoneNumberDigitCheck && context.phoneNumberDigitCheck !== 'None') {
            history.push(routes.CheckDigits);
        } else if (context.allowRecipientProvidedPhoneNumber) {
            history.push(routes.EnterPhoneNumber);
        } else if (context.displayChannel === 'EmailOnly') {
            history.push(routes.SendEmailCode);
        } else {
            history.push(routes.ChooseMethod);
        }
    }, [context, history]);

    return (
        <ContainerLayout>
            <ContainerLayout.InnerContent>
                <Center>
                    <ProgressCircle hideText text="Loading"></ProgressCircle>
                </Center>
            </ContainerLayout.InnerContent>
        </ContainerLayout>
    );
};

export default StartWorkflowPage;
